import styled from 'styled-components'

export const HeadingEmpty = styled.div`
  padding: 30px 0px 20px 0px;

  & > div {
    margin: 0 auto;
    font-size: 0.8rem;

    img {
      max-height: 100px;
    }

    p {
      margin-bottom: 12px;
    }
  }
`

export const Heading = styled.div`
  padding: 1rem;
  box-sizing: border-box;

  h4 {
    margin: 4px 0px;
  }
`
